"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from "../../ui/dialog";
import Button from "../../button-v1";
import styles from "../../../styles/case-manager-modules/DecisionModal.module.css";

const DecisionModal = ({ isOpen, onClose, onEscalate, onReview }) => {
  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Escalation Decision</DialogTitle>
        </DialogHeader>

        <DialogBody className={styles.body}>
          <p className={styles.description}>
            Do you want to escalate this event?
          </p>
        </DialogBody>

        <DialogFooter className={styles.actions}>
          <Button variant="primary" onClick={onEscalate}>
            Yes, Escalate
          </Button>
          <Button variant="ghost" onClick={onReview}>
            No, Review Only
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DecisionModal;
